import { motion } from "framer-motion";
import { Mic } from "lucide-react";

const events = [
  {
    src: "https://customer-assets.emergentagent.com/job_site-starter-kit-6/artifacts/271742kl_Tech%20Meet.png",
    alt: "Tech Meets Crypto — 19th July 2025",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_site-starter-kit-6/artifacts/6lmuysw3_Frame%202147225865.png",
    alt: "Perxels Design Challenge v2.0 — Grand Finale",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_site-starter-kit-6/artifacts/kl5xrt05_Frame%202147225867.jpg",
    alt: "Atlassian Community — Anayo speaking",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_site-starter-kit-6/artifacts/4t2tblae_Frame%202147225864.png",
    alt: "Viable Session — 21st Oct 2022 with Ifeoluwasimi Olusola",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_site-starter-kit-6/artifacts/g1ftahpb_Frame%202147225866.png",
    alt: "Live Knowledge Sharing Session #10 — User Adoption Funnel",
  },
];

export default function Speaking() {
  return (
    <section
      data-testid="speaking-section"
      className="bg-white py-24 sm:py-32"
    >
      <div className="max-w-5xl mx-auto px-6 sm:px-8 text-center">
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.7 }}
          data-testid="speaking-paragraph"
          className="font-display text-2xl sm:text-3xl lg:text-4xl font-light leading-snug tracking-tight text-zinc-900"
        >
          I&apos;ve spoken at over{" "}
          <span className="font-medium">16 conferences</span>, workshops, and
          seminars — sharing insights on product management, product design,
          and building human-centred digital experiences. If you&apos;re
          looking for a speaker who can bring energy, clarity, and actionable
          insights to your event —{" "}
          <span className="font-medium text-brand-600">let&apos;s talk.</span>{" "}
          🎤
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 12 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.15 }}
          className="mt-8"
        >
          <a
            href="#contact"
            data-testid="invite-speak-btn"
            className="inline-flex items-center gap-2 bg-zinc-950 text-white hover:bg-brand-600 transition-colors text-sm font-medium px-6 py-3 rounded-full"
          >
            <Mic className="h-4 w-4" />
            Invite Me to Speak
          </a>
        </motion.div>
      </div>

      <div className="max-w-7xl mx-auto px-6 sm:px-8 mt-16 sm:mt-20">
        <div className="grid grid-cols-2 md:grid-cols-3 gap-4 sm:gap-6">
          {events.map((e, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ duration: 0.5, delay: i * 0.05 }}
              data-testid={`event-card-${i}`}
              className="group relative rounded-2xl overflow-hidden cursor-pointer ring-1 ring-zinc-200/60"
            >
              <img
                src={e.src}
                alt={e.alt}
                loading="lazy"
                className="block w-full h-auto transition-transform duration-500 group-hover:scale-105"
              />
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
